
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'

import { Agency, AgencyUser, NotificationSettings } from '../../global/models'
import { consumeError } from '../../global/utils'
import AccountProfileDetails from '../components/AccountProfileDetails.vue'
import AgencyProfileDetails from '../components/AgencyProfileDetails.vue'
import AgencyProfileForm from '../components/AgencyProfileForm.vue'
import AgencyTypeDetails from '../components/AccountType/AgencyTypeDetails.vue'
import NotificationSettingsComponent from '../components/NotificationSettings/NotificationSettings.vue'
import { authAxios } from '../../auth/utils'

@Component({
  components: { AccountProfileDetails, AgencyProfileDetails, AgencyProfileForm, AgencyTypeDetails, NotificationSettingsComponent }
})
export default class ViewProfilePage extends Vue {
  agency: Partial<Agency> = {}

  account: Partial<AgencyUser> = {}

  settings: NotificationSettings | null = null

  editAgency = false

  editAccount = false

  slugError: string[] = []

  get agencyForm() {
    return this.$refs.agencyForm as AgencyProfileForm
  }

  async mounted() {
    await this.fetchAgencyData()
    await this.fetchAccountData()
  }

  async fetchAgencyData() {
    try {
      const response = await axios.get<Agency>(`profile`)
      this.agency = response.data
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async fetchAccountData() {
    try {
      const response = await authAxios.get<any>('')
      const settings = await axios.get<any>(`notifications`)
      this.account = response.data
      this.settings = settings.data
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  editAccountProfile() {
    this.editAccount = true
  }

  editAgencyProfile() {
    this.editAgency = true
  }

  async saveAgencyProfile() {
      this.slugError = []
    if (!this.agencyForm.validate()) {
      return
    }

    try {
      await axios.patch(`profile`, this.agency)
      this.$store.dispatch('success', 'Updated successfully')
      await this.fetchAgencyData()
      this.editAgency = false
    } catch (error) {
      const formattedError = consumeError(error)
      if (error.response.data.field === 'slug' && error.response.data.type === 'unique') {
        this.slugError = ['Slug already taken.']
      } else if (error.response.data.field === 'slug' && error.response.data.type === 'length') {
        this.slugError = ['Slug mush be 32 characters or less.']
      } else if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async saveAccount() {
    try {
      await axios.put(`/users/${this.account.id}`, this.account)
      this.fetchAccountData()
      this.editAccount = false
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async updateAccountTypes (data: Agency) {
    try {
      await axios.patch(`profile`, { ...this.agency, isMigrationAgency: !!data.isMigrationAgency, isTranslationAgency: !!data.isTranslationAgency })
      await this.$store.dispatch('auth/updateAccountType', { isMigrationAgency: !!data.isMigrationAgency, isTranslationAgency: !!data.isTranslationAgency })
      await this.fetchAgencyData()
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  updateSettings(data: NotificationSettings) {
    this.settings = data
  }
}
